import * as React from 'react';
import { WrappedFieldMetaProps } from 'redux-form';

import InputContainer from '../InputContainer/InputContainer';
import RadioGroupInput, { RadioOption } from './RadioGroupInput';

export interface RadioGroupWrapperInputProps {
  label?: string;
  input: React.InputHTMLAttributes<HTMLInputElement>;
  options: RadioOption[];
  meta: WrappedFieldMetaProps<ReduxState>;
  inline?: boolean;
}

// Redux form wrapper for radio input. Taking props.input and pass them in RadioGroupInput
const RadioGroupInputWrapper: React.SFC<RadioGroupWrapperInputProps> = ({ input, meta, label, options, inline }) => {
  const error = meta.touched && meta.error;
  return (
    <InputContainer
      error={error || undefined}
      label={label}
      name={input.name!}
      identifier="RadioGroup-textInputWrapper"
    >
      <RadioGroupInput options={options} inline={inline} inputProps={input} />
    </InputContainer>
  );
};

export const RadioGroupInputConfig = {
  component: RadioGroupInputWrapper,
};

export default RadioGroupInputWrapper;
